import { useCurrentUser } from '@tunasong/redux'
import { useDeviceState } from '@tunasong/ui-lib'
import { rememberRecent } from './move-picker-state.js'

/**
 * The folders this user last moved items to (#2543 M2), newest first. Local, as the issue allows: kept per user on
 * this device, so two accounts on one browser do not share them.
 */
export const useMoveRecents = () => {
  const { userId } = useCurrentUser()
  const [recentIds = [], setRecentIds] = useDeviceState<string[]>(`move-picker.recent.${userId ?? 'anonymous'}`, [])

  /** After a move that happened: `null` (Unfiled) is not remembered */
  const remember = (folderId: string | null) => setRecentIds(rememberRecent(recentIds, folderId))

  return { recentIds, remember }
}
